import { Modal, Box, Typography, Backdrop, Fade, styled, Button } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { red } from '@mui/material/colors';

type AlertModalProps = {
  open: boolean;
  onClose: (open: boolean) => void;
};

const AlertModal = ({ open, onClose }: AlertModalProps) => {
  const handleOnModalClick = () => {
    onClose(false);
  };

  return (
    <Modal
      closeAfterTransition
      open={open}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500
        }
      }}
    >
      <Fade in={open}>
        <ModalChildren>
          <ErrorIcon sx={{ fontSize: 70, color: red[600] }} />
          <Typography variant="h5" component="h2" sx={{ mt: 2, mb: 1, fontWeight: 600 }}>
            Perhatian
          </Typography>
          <Typography sx={{ textAlign: 'center', color: 'surface.700' }}>
            Mohon maaf proses tidak dapat dilanjutkan, NPWP <br />
            atau Izin Usaha Perusahaan telah terdaftar. Silahkan <br />
            gunakan rekening Giro Bank Sahabat Sampoerna <br />
            milik anda untuk bertransaksi atau hubungi <strong>1500 035</strong>
          </Typography>
          <Button variant="contained" color="primary" sx={{ mt: 4 }} onClick={handleOnModalClick}>
            Saya Mengerti
          </Button>
        </ModalChildren>
      </Fade>
    </Modal>
  );
};

const ModalChildren = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  minHeight: 350,
  padding: 23,
  borderRadius: 4,
  backgroundColor: theme.palette.background.paper,

  '&:focus': {
    outline: 'none'
  }
}));

export default AlertModal;
